export * from './modules/calendar.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-calendar/index.js
// module id = ./node_modules/angular-calendar/index.js
// module chunks = 3